// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3g_X4","footer":"Form_footer__23CTQ"};